// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { BarList, type BarRow } from './BarList';
import { Empty } from '../ui';

const COLS = ['#DC143C', '#9F1239', '#fda4af', '#d6d3d1', '#78716c'];

/** Ring + percentage legend (legend rows clickable). Ported from the mockup's donut(). */
export const Donut: React.FC<{ parts: BarRow[]; testId?: string }> = ({ parts, testId }) => {
  const tot = parts.reduce((s, p) => s + p.value, 0);
  if (!parts.length || !tot) return <Empty />;
  const r = 52, c = 60;
  let a = 0;
  const arcs = parts.slice(0, COLS.length).map((p, i) => {
    const f = p.value / tot;
    // A single 100% slice cannot be drawn as one arc — use a full circle.
    if (f >= 0.9999) return <circle key={p.key} cx={c} cy={c} r={r} stroke={COLS[i]} strokeWidth={16} fill="none" />;
    const a2 = a + f * Math.PI * 2;
    const d = `M${c + r * Math.sin(a)},${c - r * Math.cos(a)}A${r},${r} 0 ${f > 0.5 ? 1 : 0} 1 ${c + r * Math.sin(a2)},${c - r * Math.cos(a2)}`;
    a = a2;
    return <path key={p.key} d={d} stroke={COLS[i]} strokeWidth={16} fill="none" />;
  });
  const legend: BarRow[] = parts.slice(0, COLS.length).map((p, i) => ({
    ...p,
    label: (<><i className="inline-block w-2 h-2 rounded-sm mr-1.5" style={{ background: COLS[i] }} />{p.label}</>),
    value: Math.round((p.value / tot) * 100),
  }));
  return (
    <div className="flex gap-4 items-center" data-testid={testId}>
      <svg width={120} height={120} className="shrink-0" role="img" aria-label="Donut chart">{arcs}</svg>
      <div className="flex-1 min-w-0"><BarList rows={legend} format={(v) => `${v}%`} limit={COLS.length} noFill /></div>
    </div>
  );
};
